import apiClient from "@/app/api/client";
import type { ListParams } from "@/shared/types/api";

export const nvrService = {
	list(params?: ListParams) {
		return apiClient.get("/nvrs", { params }).then((r) => r.data);
	},
	get(id: number) {
		return apiClient.get(`/nvrs/${id}`).then((r) => r.data);
	},
	create(data: Record<string, unknown>) {
		return apiClient.post("/nvrs", data).then((r) => r.data);
	},
	update(id: number, data: Record<string, unknown>) {
		return apiClient.patch(`/nvrs/${id}`, data).then((r) => r.data);
	},
	remove(id: number) {
		return apiClient.delete(`/nvrs/${id}`).then((r) => r.data);
	},
	sync(id: number) {
		return apiClient.post(`/nvrs/${id}/sync`).then((r) => r.data);
	},
};
